<template>
  <div v-loading="loading">
    <div class="title-div">燃气登录</div>
    <div class="form-div">
      <el-form ref="form" :model="form" label-width="80px" label-position="top" :rules="rules" hide-required-asterisk>
        <el-form-item label="账号：" prop="accountNumber">
          <el-input v-model="form.accountNumber" placeholder="请输入您的手机号" maxlength="11"
                    class="password-input"></el-input>
        </el-form-item>
        <el-form-item label="密码：" prop="pass">
          <el-input type="password" v-model="form.pass" autocomplete="off" placeholder="请输入密码" maxlength="20"
                    class="password-input"></el-input>
          <span class="forget-password-span" @click="toPasswordReset()">忘记密码？</span>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" class="submit-button" @click="onSubmit">提交</el-button>
        </el-form-item>
        <el-form-item>
          <el-button plain class="register-button" @click="toRegister()">快速注册</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
  import { getToken, getUserId, getUserInfo } from '../../api/login'
  import { passwordEncryption } from '../../utils/jsencrypt'

  export default {
    name: 'PCLogin',
    data () {
      return {
        form: {
          accountNumber: '', // 账号
          pass: '' // 密码
        },
        rules: {
          accountNumber: [
            {
              required: true,
              message: '请输入您的手机号',
              trigger: 'blur'
            }
          ],
          pass: [
            {
              required: true,
              message: '请输入密码',
              trigger: 'blur'
            }
          ]
        }, // 校验规则
        loading: false // 是否显示加载提示
      }
    },
    methods: {
      // 提交
      onSubmit () {
        const that = this
        that.$refs['form'].validate((valid) => {
          if (valid) {
            that.loading = true
            const params = {
              client_id: 'a8117f61-0643-43ba-a172-bca68f497051',
              client_secret: 'a376a615-1ba6-453f-8e30-f68ae0b1b3f9',
              grant_type: 'password',
              username: passwordEncryption(that.form.accountNumber),
              password: passwordEncryption(that.form.pass)
            }
            getToken(params).then(res => {
              that.loading = false
              that.onLogin(res.data)
            }).catch(() => {
              that.loading = false
              that.$message.error('用户名或密码错误');
            })
          } else {
            return false;
          }
        });
      },

      // 获取token成功
      onLogin (resp) {
        window.localStorage.smartHistory = ''
        if (resp.access_token) {
          this.$message({
            message: '登录成功',
            type: 'success'
          });
          window.localStorage.tokenType = resp.token_type
          window.localStorage.token = resp.access_token
          this.getUserIdData(resp.access_token)
        } else {
          this.$message.error('登录失败');
        }
      },

      // 根据token获取用户id
      getUserIdData (val) {
        getUserId(val).then(res => {
          window.localStorage.userId = res.data.rows[0].userId
          this.getUserInfoData(res.data.rows[0].userId)
        }).catch(() => {
          this.$message.error('获取用户id失败');
        })
      },

      // 根据用户id获取用户信息
      getUserInfoData (id) {
        getUserInfo(id).then(res => {
          window.localStorage.userInfo = JSON.stringify(res.data.rows[0])
          this.$router.replace('/pcAccountNumberManagement')
        }).catch(() => {
          this.$message.error('获取用户信息失败');
        })
      },

      // 快速注册
      toRegister () {
        this.$router.push('/pcRegister')
      },

      // 跳转到密码重置页面
      toPasswordReset () {
        this.$router.push('/pcPasswordReset')
      }
    }
  }
</script>

<style scoped>
  .title-div {
    width: 88.5%;
    height: 158px;
    background: #BD1A2D;
    font-size: 38px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #FFFFFF;
    line-height: 158px;
    padding-left: 11.5%;
  }

  .form-div {
    padding: 47px 33% 57px 38%;
  }

  .submit-button {
    width: 80%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #FFFFFF;
    height: 40px;
    padding: 0;
  }

  .el-button--primary {
    background-color: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button--primary:focus, .el-button--primary:hover {
    background: #BD1A2D;
    border-color: #BD1A2D;
  }

  .el-button {
    border-radius: 0px 2px 2px 0px;
    border: 1px solid #BD1A2D;
  }

  .register-button {
    width: 80%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #BD1A2D;
    height: 40px;
    padding: 0;
  }

  /deep/ .el-form--label-top .el-form-item__label {
    font-size: 18px;
    font-family: MicrosoftYaHei-Bold, MicrosoftYaHei;
    font-weight: bold;
    color: #333333;
  }

  .el-button.is-plain:focus, .el-button.is-plain:hover {
    background: #FFF;
    border-color: #BD1A2D;
    color: #BD1A2D;
  }

  .password-input {
    width: 80%;
  }

  .forget-password-span {
    font-size: 14px;
    font-family: MicrosoftYaHei;
    color: #BD1A2D;
    margin-left: 4%;
  }
</style>
